import * as R from 'ramda';
import { createLogic } from 'redux-logic';
// common
import { globalCleanReports } from '../../common/actions';
// features
import { sendLogOutRequest } from '../auth/actions';
import { receivedSwitchBranchSuccess } from '../branch/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature payroll
import { validateCreatePayroll } from './helpers';
import { addPayrolls, setInitialState, createDriversPayrollRequest } from './actions';
import { addPayrolls as addVendorPayrolls, createVendorPayrollsRequest } from './vendor-payroll/actions';
//////////////////////////////////////////////////

const handleAddPayrolls = createLogic({
  type: addPayrolls,
  validate({ getState, action }, allow, reject) {
    const drivers = action.payload;
    const state = getState();
    const configs = R.path(['payrolls', 'currentBranchConfigs'], state);
    const autoPayrollNumber = G.getConfigValueFromStore(
      GC.INVOICE_TEL_PAYROLL_NUMBER_AUTOGENERATED,
      configs,
    );
    if (R.not(validateCreatePayroll(drivers, autoPayrollNumber))) {
      G.showToastrMessageSimple(
        'info',
        G.getWindowLocale('messages:payroll-number-required', 'Payroll number is required'),
      );
      return reject();
    }
    allow(action);
  },
});

const handleCreateDriverPayrolls = createLogic({
  type: createDriversPayrollRequest,
  validate({ getState, action }, allow, reject) {
    if (G.isNilOrEmpty(R.path(['payload', 'driverGuids'], action))) {
      G.showToastrMessageSimple(
        'info',
        G.getWindowLocale('messages:select-drivers', 'Please, select at least one driver'),
      );
      return reject();
    }
    allow(action);
  },
});

const handleAddVendorPayrolls = createLogic({
  type: addVendorPayrolls,
  validate({ getState, action }, allow, reject) {
    const drivers = action.payload;
    const state = getState();
    const configs = R.path(['payrolls', 'currentBranchConfigs'], state);
    const autoPayrollNumber = G.getConfigValueFromStore(
      GC.INVOICE_FLEET_VENDOR_PAYROLL_NUMBER_AUTOGENERATED,
      configs,
    );
    if (R.not(validateCreatePayroll(drivers, autoPayrollNumber))) {
      G.showToastrMessageSimple(
        'info',
        G.getWindowLocale('messages:payroll-number-required', 'Payroll number is required'),
      );
      return reject();
    }
    allow(action);
  },
});

const handleCreateVendorPayrolls = createLogic({
  type: createVendorPayrollsRequest,
  validate({ getState, action }, allow, reject) {
    if (G.isNilOrEmpty(R.path(['payload', 'fleetVendorGuids'], action))) {
      G.showToastrMessageSimple(
        'info',
        G.getWindowLocale('messages:select-vendors', 'Please, select at least one vendor'),
      );
      return reject();
    }
    allow(action);
  },
});

const handleSwitchBranchOrChangeLocationLogic = createLogic({
  type: [
    sendLogOutRequest,
    globalCleanReports,
    GC.LOCATION_CHANGE_ACTION,
    receivedSwitchBranchSuccess,
  ],
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ action }, dispatch, done) {
    const pathname = R.pathOr('', ['payload', 'pathname'], action).replace(/\/+$/, '');

    const isEnteringPayrolls = action.type === GC.LOCATION_CHANGE_ACTION
      && pathname === GC.ROUTE_PATH_DRIVER_PAYROLL_LIST;

    if (isEnteringPayrolls) return done();

    dispatch(setInitialState());
    done();
  },
});

export default [
  handleAddPayrolls,
  handleAddVendorPayrolls,
  handleCreateDriverPayrolls,
  handleCreateVendorPayrolls,
  handleSwitchBranchOrChangeLocationLogic,
];
